<template>
  <v-card
    style="max-height: 300px; height: 300px; overflow: scroll; overflow-x: hidden;"
  >
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>Resources</h4></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon class="text--secondary" @click="handleResourcesList()"
        >refresh</v-icon
      >
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table
          :headers="headers"
          :items="list"
          hide-actions
          class="elevation-0"
        >
          <template slot="items" slot-scope="props">
            <td>{{ titleCase(props.item.holder_type) }}</td>
            <td>
              {{ [props.item.first_name, props.item.last_name].join(" ") }}
            </td>
            <td class="text-xs-left">
              {{ props.item.out_date + " " + props.item.out_time }}
            </td>
            <td class="text-xs-right">
              {{
                props.item.resources_name + " (" + props.item.resources_id + ")"
              }}
            </td>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
import APIResource from "@/mixins/APIResource";
export default {
  mixins: [APIResource],
  props: {
    type: {
      format: String,
      default: "Students"
    }
  },
  data() {
    return {
      headers: [
        {
          text: "Type",
          align: "left",
          value: "holder_type"
        },
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Date/Time", value: "progress", align: "center" },
        { text: "Resource Name", value: "reason", align: "right" }
      ],
      list: []
    };
  },
  watch: {
    type: {
      handler() {
        this.handleResourcesList();
      }
    }
  },
  created() {
    this.handleResourcesList();
  },
  methods: {
    handleResourcesList: async function() {
      let list = await this.listResourcesInOut(this.filtermode);
      this.list = list.filter(obj => {
        return obj.sign_type == "out" && obj.complete_id == null;
      });
      // if (this.filtermode) {
      //   list = list.filter(obj => {
      //     if (this.filtermode === "out") {
      //       return obj.sign_type === this.filtermode && !obj.complete_id;
      //     } else {
      //       return obj.sign_type === this.filtermode;
      //     }
      //   });
      // }
      // this.filteredList = list;
    }
  }
};
</script>
